import { CHANGE_LANGUAGE } from "../constants/languageConstant";

export const languageReducer = (state= {}, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return {language: action.payload}
        default:
            return state;
    }
}